import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const SubscriptionSuccess: React.FC = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-4 py-20">
      <SEO 
        title="Subscription Successful | David Sheeshka"
        description="Thank you for subscribing to my newsletter"
        keywords="newsletter, subscription, web development"
        url="https://davidsheeshka.com/subscription-success"
      />
      
      <div className="bg-gradient-to-b from-[#1E293B] to-[#0F172A] rounded-xl p-8 shadow-xl">
        <div className="text-center">
          <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          
          <h1 className="text-3xl font-bold mb-4">Subscription Successful!</h1>
          <p className="text-gray-300 mb-6">
            Thank you for subscribing to my newsletter. You'll be the first to know when I publish new content.
          </p>
          <p className="text-gray-300 mb-8">
            A confirmation email has been sent to your inbox. Please confirm your subscription by clicking the link in the email.
          </p>
          
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/" className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
              Return to Homepage
            </Link>
            <Link to="/blog" className="px-6 py-3 border border-blue-500 text-blue-400 rounded-lg hover:bg-blue-500/10 transition-colors">
              Explore Blog Posts
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSuccess;
